import React, { useCallback, useState, useEffect } from "react";
import { fireStore } from "../../firebaseConfig";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import Cookies from "js-cookie";

const Login = ({ onLogin }) => {
  // Receive onLogin function as a prop
  const [signupRequests, setSignupRequests] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate

  const fetchSignupRequests = useCallback(() => {
    try {
      const collectionRef = collection(fireStore, "SignupRequests");
      const q = query(collectionRef, where("approved", "in", [true, false]));

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const requestsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSignupRequests(requestsList);
      });

      return unsubscribe; // Return the unsubscribe function
    } catch (error) {
      console.error("Error fetching signup requests:", error);
    }
  }, []);

  useEffect(() => {
    const unsubscribe = fetchSignupRequests();
    return () => unsubscribe(); // Cleanup the listener on unmount
  }, [fetchSignupRequests]);

  const handleLogin = async (e) => {
    e.preventDefault();
    const user = signupRequests.find(
      (req) =>
        req.user?.phone === phoneNumber &&
        req.password === password &&
        req.user?.role === selectedRole // Check against the selected role
    );

    if (user) {
      // Create a JWT (for simplicity, using a mock token here)
      const mockToken = "your_jwt_token_here"; // You would get this from your backend

      // Store the JWT in a cookie for 7 days
      Cookies.set("authToken", mockToken, { expires: 7 });

      console.log(`Logged in as ${selectedRole}`);

      // Store the user's role in a cookie (ensure you handle this securely)
      Cookies.set("userRole", user.user?.role, { expires: 7 });

      console.log(mockToken);

      onLogin(); // Call the onLogin prop function
      sessionStorage.setItem("PASSWORD", password);
      navigate("/"); // Redirect to the homepage
    } else {
      setError("Invalid phone number or password and Role");
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className="bg-liquidblue h-screen flex items-center justify-center min-h-screen">
      <div className="custom-container-outer flex items-center justify-center">
        <div className="custom-container-inner p-8">
          <div className="flex flex-col ">
            <h1 className="text-4xl font-bold text-darkgreen mb-6 text-end ">
              FERTISCIENCE
            </h1>
            <h1 className="text-8xl font-bold text-darkgreen mb-6 text-end">
              FSR
            </h1>
          </div>
          <form className="space-y-4" onSubmit={handleLogin}>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.4 18.0742C18.9 18.0742 17.46 17.8281 16.116 17.3729C15.696 17.2375 15.228 17.3359 14.892 17.6805L12.252 20.3875C8.856 18.6156 6.072 15.7609 4.344 12.2787L6.984 9.57168C7.32 9.22715 7.416 8.74727 7.284 8.3166C6.84 6.93848 6.6 5.46191 6.6 3.92383C6.6 3.59749 6.47357 3.28451 6.24853 3.05376C6.02348 2.823 5.71826 2.69336 5.4 2.69336H1.2C0.88174 2.69336 0.576515 2.823 0.351472 3.05376C0.126428 3.28451 0 3.59749 0 3.92383C0 9.47162 2.14928 14.7922 5.97502 18.7151C9.80076 22.6379 14.9896 24.8418 20.4 24.8418C20.7183 24.8418 21.0235 24.7122 21.2485 24.4814C21.4736 24.2506 21.6 23.9377 21.6 23.6113V19.3047C21.6 18.9783 21.4736 18.6654 21.2485 18.4346C21.0235 18.2039 20.7183 18.0742 20.4 18.0742ZM18 12.5371L24 6.38477L18 0.232422V3.92383H13.2V8.8457H18V12.5371Z"
                    fill="#D9D9D9"
                  />
                </svg>
              </span>
              <select
                className="pl-10 pr-4 py-2 w-full border rounded-full bg-liquidblue"
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
                required
              >
                <option value="" disabled className="bg-white">
                  Select Role
                </option>
                <option value="ADMIN" className="bg-white">
                  ADMIN
                </option>
                <option value="HSM" className="bg-white">
                  HSM
                </option>
                <option value="CEO" className="bg-white">
                  CEO
                </option>
              </select>
            </div>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.4 18.0742C18.9 18.0742 17.46 17.8281 16.116 17.3729C15.696 17.2375 15.228 17.3359 14.892 17.6805L12.252 20.3875C8.856 18.6156 6.072 15.7609 4.344 12.2787L6.984 9.57168C7.32 9.22715 7.416 8.74727 7.284 8.3166C6.84 6.93848 6.6 5.46191 6.6 3.92383C6.6 3.59749 6.47357 3.28451 6.24853 3.05376C6.02348 2.823 5.71826 2.69336 5.4 2.69336H1.2C0.88174 2.69336 0.576515 2.823 0.351472 3.05376C0.126428 3.28451 0 3.59749 0 3.92383C0 9.47162 2.14928 14.7922 5.97502 18.7151C9.80076 22.6379 14.9896 24.8418 20.4 24.8418C20.7183 24.8418 21.0235 24.7122 21.2485 24.4814C21.4736 24.2506 21.6 23.9377 21.6 23.6113V19.3047C21.6 18.9783 21.4736 18.6654 21.2485 18.4346C21.0235 18.2039 20.7183 18.0742 20.4 18.0742ZM18 12.5371L24 6.38477L18 0.232422V3.92383H13.2V8.8457H18V12.5371Z"
                    fill="#D9D9D9"
                  />
                </svg>
              </span>
              <input
                className="pl-10 pr-4 py-2 w-full border rounded-full bg-liquidblue"
                type="text"
                placeholder="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </div>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 22 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1429 14.7578C17.5314 14.7578 17.9086 14.8047 18.2857 14.8633V11.2422C18.2857 9.95312 17.2686 8.89844 16 8.89844H14.8571V6.55469C14.8571 3.32031 12.2971 0.695312 9.14286 0.695312C5.98857 0.695312 3.42857 3.32031 3.42857 6.55469V8.89844H2.28571C1.02857 8.89844 0 9.94141 0 11.2422V22.9609C0 24.2617 1.01714 25.3047 2.28571 25.3047H11.2114C10.6286 24.2734 10.2857 23.0781 10.2857 21.7891C10.2857 17.9102 13.36 14.7578 17.1429 14.7578ZM5.71429 6.55469C5.71429 4.60938 7.24571 3.03906 9.14286 3.03906C11.04 3.03906 12.5714 4.60938 12.5714 6.55469V8.89844H5.71429V6.55469ZM9.14286 19.4453C7.88571 19.4453 6.85714 18.4023 6.85714 17.1016C6.85714 15.8008 7.88571 14.7578 9.14286 14.7578C10.4 14.7578 11.4286 15.8008 11.4286 17.1016C11.4286 18.4023 10.4114 19.4453 9.14286 19.4453ZM21.1429 19.7383L15.7143 25.3047L12.5714 21.7891L13.8971 20.4297L15.7143 22.293L19.8171 18.0859L21.1429 19.7383Z"
                    fill="#D9D9D9"
                  />
                </svg>
              </span>
              <input
                className="pl-10 pr-4 py-2 w-full border rounded-full bg-liquidblue"
                type={passwordVisible ? "text" : "password"} // Conditional type based on visibility state
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 flex items-center pr-3"
                onClick={togglePasswordVisibility}
              >
                {passwordVisible ? (
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 5C7 5 2.73 7.61 1 12C2.73 16.39 7 19 12 19C17 19 21.27 16.39 23 12C21.27 7.61 17 5 12 5ZM12 17C8.14 17 4.74 15.1 3 12C4.74 8.9 8.14 7 12 7C15.86 7 19.26 8.9 21 12C19.26 15.1 15.86 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9ZM12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13Z"
                      fill="#000000"
                    />
                  </svg>
                ) : (
                  <svg
                    width="15px"
                    height="15px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <g id="style=linear">
                        {" "}
                        <g id="eye-close">
                          {" "}
                          <path
                            id="vector"
                            d="M15.6487 5.39489C14.4859 4.95254 13.2582 4.72021 12 4.72021C8.46997 4.72021 5.17997 6.54885 2.88997 9.71381C1.98997 10.9534 1.98997 13.037 2.88997 14.2766C3.34474 14.9051 3.83895 15.481 4.36664 16.0002M19.3248 7.69653C19.9692 8.28964 20.5676 8.96425 21.11 9.71381C22.01 10.9534 22.01 13.037 21.11 14.2766C18.82 17.4416 15.53 19.2702 12 19.2702C10.6143 19.2702 9.26561 18.9884 7.99988 18.4547"
                            stroke="#000000"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>{" "}
                          <path
                            id="vector_2"
                            d="M15 12C15 13.6592 13.6592 15 12 15M14.0996 9.85541C13.5589 9.32599 12.8181 9 12 9C10.3408 9 9 10.3408 9 12C9 12.7293 9.25906 13.3971 9.69035 13.9166"
                            stroke="#000000"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>{" "}
                          <path
                            id="vector_3"
                            d="M2 21.0002L22 2.7002"
                            stroke="#000000"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          ></path>{" "}
                        </g>{" "}
                      </g>{" "}
                    </g>
                  </svg>
                )}
              </button>
            </div>
            {error && <div className="text-red-500">{error}</div>}
            <div className="w-full flex justify-center">
              <button
                className="px-7 py-2 bg-darkgreen text-white font-semibold rounded-full hover:bg-darkteal transition duration-300"
                type="submit"
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
